import React, { Component } from "react";
import img from "../img/Mask.png";
import { MdArrowBackIos, MdOutlineLocationOn } from "react-icons/md";

export default class LeftContent extends Component {
  render() {

    return (
      <>

        {/* back btn */}
        <div
          className="row rowMar mt-lg-1 pt-lg-4 mt-0 pt-0 d-lg-block d-none"
          onClick={this.props.gotoMomKidCare}
        >
          <div className="back-to-mkc row">
            <div className="col"><MdArrowBackIos size="18" className="mt-n3" />
              <span style={{ width: '50px', display: 'inline-block', lineHeight: '1.1' }}> Back To Momkidcare.com</span></div>
          </div>
        </div>
        {/* Title */}
        <div className="row mt-1">
          <div className="col-lg-12 col-12 title">
            <p>Babysitter/ Nanny/ Japa & Baby Mother Massage Jobs</p>
          </div>
        </div>
        {/* Image */}
        <div className="row">
          <div className="col-lg-12">
            <img
              src={img}
              width="290"
              height="290"
              className="d-lg-block d-none"
            />
            <img
              src={img}
              width="200"
              height="200"
              className="d-lg-none d-block mx-auto"
            />
          </div>
        </div>
      </>
    );
  }
}